<template>
  <v-tabs
    fixed-tabs
    fill-height
    v-model="active"
    slider-color="primary"
    class="grey lighten-4"
    style="min-height: 600px !important;"
  >
    <!-- MORE INFO -->
    <v-tab :label="`OVERVIEW`">OVERVIEW</v-tab>
    <v-tab-item>
      <v-layout column>
        <div style="height: 15px;"></div>

        <v-card width="95%" style="margin:auto; text-align:center;">
          <v-img
            class="white--text overview-icon"
            height="150px"
            v-bind:src="createURL(sponsor.icon.handle)"
          ></v-img>
          <v-divider primary></v-divider>
          <v-card-text style="padding: 5%; text-align: left;">
            <span class="text--primary">
              <v-icon large>icons8-trophy</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{{game.competition}}</span>
              <v-divider></v-divider>
              <br />
              <v-icon large>icons8-tournament</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{{game.gameName}}</span>
              <v-divider></v-divider>
              <br />
              <v-icon large>icons8-stadium-2</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{{game.venue}}</span>
              <v-divider></v-divider>
              <br />
              <v-icon large>icons8-tv-antenna</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>{{game.tvChannel}}</span>
              <v-divider></v-divider>
            </span>
          </v-card-text>
          <v-layout row wrap align-center justify-space-around primary style="padding: 4%;">
            <v-flex xs3>
              <v-icon x-large center class="white--text">icons8-static-views</v-icon>
              <br />
              <span class="white--text">{{game.viewing}}</span>
            </v-flex>
            <v-divider vertical style="border-color:white"></v-divider>
            <v-flex xs3>
              <v-icon x-large center class="white--text">icons8-scoreboard</v-icon>
              <br />
              <span class="white--text">{{game.result}}</span>
            </v-flex>
            <v-divider vertical style="border-color:white"></v-divider>
            <v-flex xs3>
              <v-icon x-large center class="white--text">icons8-crowd</v-icon>
              <br />
              <span class="white--text">{{game.attendence}}</span>
            </v-flex>
          </v-layout>
        </v-card>
        <div style="height: 15px;"></div>
      </v-layout>
    </v-tab-item>

    <!-- REVIEW -->
    <v-tab :label="`CLIPS`">CLIPS</v-tab>
    <v-tab-item>
      <div style="height: 15px;"></div>

      <v-card width="95%" style="margin:auto; text-align:center;">
        <v-layout row wrap align-center justify-center>
          <!-- padding: 10px 21px 0px 21px !important -->
          <v-flex xs6 style="border: 0px solid red !important; max-height: 50px !important;">
            <v-text-field
              v-model="selected"
              name="location;clarity"
              solo
              label="Search"
              height="50px"
              prepend-inner-icon="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 style="border: 0px solid red !important; max-height: 50px !important;">
            <v-select
              v-model="selected"
              :items="rows"
              item-text="type"
              item-value="type"
              solo
              label="Type"
              height="50px"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <div class="report-table-container">
            <vue-good-table
              :columns="Columns"
              :rows="rows"
              responsive
              styleClass="vgt-table responsive condensed"
              class="sponsors-report-table"
              row-style-class="tablerowheight"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 7,
                position: 'bottom',
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
              }"
              :search-options="{
                enabled: true,
                externalQuery:  selected
                         }"
            >
              <template slot="table-column" slot-scope="props">
                <span class="tablerowheight subheading font-weight-thin">{{props.column.label}}</span>
              </template>

              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'clipStart'" class="subheading">
                  <span>{{changeTimeFormat(props.row.clipStart)}}</span>
                </span>
                <span v-if="props.column.field == 'clipDuration'" class="subheading">
                  <span style="text-align: center">{{changeTimeFormat(props.row.clipDuration)}}</span>
                </span>
                <span v-if="props.column.field == 'clarity'" class="subheading">
                  <span style="text-align: center">{{(props.row.clarity)}}</span>
                </span>
                <span v-if="props.column.field == 'location'" class="subheading">
                  <span style="text-align: center">{{(props.row.location)}}</span>
                </span>
                <span v-if="props.column.field == 'action'">
                  <v-icon
                    medium
                    center
                    class="primary--text"
                    @click="pressButton(props.row.clipStart, props.row.clipDuration, props.row.name)"
                  >icons8-play</v-icon>
                </span>
              </template>
            </vue-good-table>
          </div>
        </v-layout>
      </v-card>
      <div style="height: 15px;"></div>
    </v-tab-item>

    <!-- STATS -->
    <v-tab :label="`STATS`">STATS</v-tab>
    <v-tab-item>
      <v-layout column>
        <div style="height: 15px;"></div>
        <v-card width="95%" style="margin:auto; text-align:center;">
          <p class="stats-title primary--text">Locations by airtime</p>
          <div id="pie-chart-report" data-rows="filteredRows"></div>
          <div class="more-info pl-1 pr-3 mt-2">
            <table width="100%" border="0">
              <tr>
                <td class="more-info-title primary--text">Total airtime:</td>
                <td>{{computeAirtime()}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Ad frequency:</td>
                <td>{{computeAdFrequncy()}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Total Dwell time:</td>
                <td>{{computeDwellAirtime()}}</td>
              </tr>
            </table>
          </div>
          <div style="height: 30px;"></div>
        </v-card>
        <div style="height: 15px;"></div>
      </v-layout>
    </v-tab-item>

    <!-- TIMELINE
    <v-tab :label="`TIMELINE`" v-if="!isMobile()">TIMELINE</v-tab>
    <v-tab-item>
      <v-layout column>
        <div style="height: 15px;"></div>
        <v-card width="95%" style="margin:auto; text-align:center;">
          <Timeline />
        </v-card>
        <div style="height: 15px;"></div>
      </v-layout>
    </v-tab-item>-->
  </v-tabs>
</template>

<script>
import { mapState } from "vuex";
import "@/components/video";
import "@/components/forms";
import adminSchema from "@/schemas/admin.json";
import CRUD from "@/firebase/crud";
import { setTimeout } from "timers";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);
import { filestack } from "@/components/mixins/filestack.js";
import Timeline from "@/components/charts/SponsorsReportTimeline.vue";

export default {
  mixins: [filestack],
  components: {
    Timeline
  },
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      // tableRows: 5,
      active: null,
      rows: [],
      game: [],
      sponsor: [],
      selected: "",
      tableOptions: {
        enabled: true,
        mode: "records",
        perPage: 7,
        position: "bottom",
        setCurrentPage: 1,
        nextLabel: "next",
        prevLabel: "prev",
        ofLabel: "of",
        pageLabel: "page", // for 'pages' mode
        allLabel: "All"
      },
      filteredRows: []
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      clip: state => state.clip,
      actionsBtns: state => state.actionsBtns,
      sID: state => state.report.sponsorID,
      gID: state => state.report.gameID,
      sName: state => state.report.sponsorName,
      DocByID: state => state.Admin.DocByID,
      sponByGameResult: state => state.clip.sponByGameResult,
      SecondDocByID: state => state.Admin.SecondDocByID
    }),
    Columns() {
      return adminSchema.sponsorReport.columns;
    },
    pageWidth() {
      return this.$vuetify.breakpoint.width;
    },
    PieLabels() {
      return this.filteredRows;
    }
  },
  watch: {
    pageWidth() {
      this.updateTableRows(this.$vuetify.breakpoint.name);
    },
    sponByGameResult: {
      handler: function() {
        this.rows = this.$sortBy(this.sponByGameResult, "clipStart");
        this.filteredRows = this.sponByGameResult;
        this.filteredRows = [];
        this.computeAirtimeByLocation();
      },

      immediate: true,
      deep: true
    },
    watchRows: {
      handler: function() {
        this.filteredRows;
      },
      deep: true
    },
    Columns: {
      handler: function() {
        this.tableCol = this.Columns;
      }
    },
    DocByID: {
      handler: function() {
        this.game = this.DocByID;
      },
      deep: true
    },
    DocResultByID: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    // sponsor
    SecondDocByID: {
      handler: function() {
        this.sponsor = this.SecondDocByID;
        //console.log("Sponsor: " + JSON.stringify(this.sponsor, null, 2));
        //console.log(this.sponsor.icon.handle);
      },
      deep: true
    },
    SecondDocResultByID: {
      handler: function() {
        this.readSponsorGame();
      },
      deep: true
    }
  },
  methods: {
    updateTableRows(breakpoint) {
      switch (breakpoint) {
        case "xs":
          this.tableOptions.perPage = 5;
          break;
        case "sm":
          this.tableOptions.perPage = 5;
          break;
        case "md":
          this.tableOptions.perPage = 10;
          break;
        case "lg":
          this.tableOptions.perPage = 10;
          break;
        case "xl":
          this.tableOptions.perPage = 10;
          break;
        default:
          this.tableOptions.perPage = 5;
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    getSponsorClipsByGame() {
      // console.log("sponsor = ", this.sID, "\ngameID ", this.gID);
      this.$store.dispatch("clip/getSponsorClipsByGame", [
        "clips",
        this.portal.active.id,
        this.sID,
        this.gID,
        "clip/setSponByGameResult"
      ]);
      //console.log("return rows: " + JSON.stringify(this.rows, null, 2));
    },
    readGames() {
      // console.log("GAME ID: " + this.gID);
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.gID,
        "Admin/setDocByID"
      ]);
    },
    readSponsorGame() {
      this.$store.dispatch("Admin/readDocumentByID", [
        "sponsors",
        this.sID,
        "Admin/setSecondDocByID"
      ]);
    },
    pressButton(startTime, duration) {
      this.$store.commit("actionsBtns/setButtonEmpty");
      this.$store.commit("actionsBtns/setButtonPressed", "playGameMoment");
      this.$store.dispatch("actionsBtns/sendData", [
        startTime,
        duration,
        "actionsBtns/setResult"
      ]);
    },
    changeTimeFormat(time) {
      var s = Math.floor(time % 60);
      var m = Math.floor((time / 60) % 60);
      var h = Math.floor(time / 3600);
      if (isNaN(time) || time === Infinity) {
        h = m = s = "--";
      }
      h = h > 0 ? h + ":" : "";
      m = (h && m < 10 ? "0" + m : m) + ":";
      s = s < 10 ? "0" + s : s;
      return (time = h + m + s);
    },
    //filter rows to add when locations are the same
    computeAirtimeByLocation() {
      var newRows = [];
      if (this.sponByGameResult != null) {
        this.sponByGameResult.forEach(function(a) {
          if (!this[a.location]) {
            this[a.location] = { location: a.location, clipDuration: 0 };
            newRows.push(this[a.location]);
          }
          this[a.location].clipDuration += a.clipDuration;
        }, Object.create(null));
      }

      newRows = this.$sortBy(newRows, "clipDuration");
      newRows = newRows.reverse();
      newRows = newRows.slice(0, 5);
      this.filteredRows = newRows.reverse();
      // console.log(
      //   "computeAir... graf data: " + JSON.stringify(this.filteredRows, null, 2)
      // );
    },
    createChart() {
      // Create chart instance
      var chart = am4core.create("pie-chart-report", am4charts.PieChart);

      // Add data
      chart.data = this.filteredRows; // update chart data when changing rows
      // console.log(
      //   "createChart graf data: " + JSON.stringify(this.filteredRows, null, 2)
      // );

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "clipDuration";
      pieSeries.dataFields.category = "location";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      pieSeries.slices.template.strokeWidth = 0;
      chart.tapToActivate = true;
      // Add legend
      chart.legend = new am4charts.Legend();
    },
    orientationChange() {
      this.createChart();
      //console.log("Orientation changed");
    },
    resize() {
      this.createChart();
      //console.log("Page resized");
    },
    computeAirtime() {
      var airtimeRows = this.sponByGameResult;

      airtimeRows = this.$_(airtimeRows)
        .groupBy("sponsor")
        .map((objs, key) => {
          return {
            sponsor: key,
            clipDuration: this.$_.sumBy(objs, "clipDuration")
          };
        })
        .value();
      //console.log("airtime rows: " + JSON.stringify(airtimeRows, null, 2));

      for (var i = 0; i < airtimeRows.length; i++) {
        var airtime = airtimeRows[i].clipDuration;
        //console.log("airtime: " + airtimeRows[i].clipDuration);
      }
      airtime = this.changeTimeFormat(airtime);
      return airtime;
    },
    computeDwellAirtime() {
      var dwelltimeRows = this.$filter(this.sponByGameResult, {
        type: "Dwell"
      });

      dwelltimeRows = this.$_(dwelltimeRows)
        .groupBy("sponsor")
        .map((objs, key) => {
          return {
            sponsor: key,
            clipDuration: this.$_.sumBy(objs, "clipDuration")
          };
        })
        .value();

      //console.log("airtime rows: " + JSON.stringify(airtimeRows, null, 2));
      for (var i = 0; i < dwelltimeRows.length; i++) {
        var dwelltime = dwelltimeRows[i].clipDuration;
        //console.log("airtime: " + airtimeRows[i].clipDuration);
      }
      dwelltime = this.changeTimeFormat(dwelltime);
      return dwelltime;
    },
    computeAdFrequncy() {
      var frequencyRows = this.sponByGameResult;

      frequencyRows = this.$_(frequencyRows)
        .groupBy("sponsor")
        .map((objs, key) => {
          return {
            sponsor: key,
            count: this.$_.sumBy(objs, x => (x ? 1 : 0)) //this.$_.countBy(objs),
          };
        })
        .value();
      // console.log("ad frequnecy: " + JSON.stringify(frequencyRows, null, 2));

      for (var i = 0; i < frequencyRows.length; i++) {
        var count = frequencyRows[i].count;
        // console.log("count: " + frequencyRows[i].count);
      }
      return count;
    }
  },
  created() {
    this.updateTableRows(this.$vuetify.breakpoint.name);
    var v = this;
    window.addEventListener("orientationchange", v.orientationChange, false);
    window.addEventListener("resize", v.resize, false);
  },
  mounted() {
    var v = this;
    this.updateTableRows(this.$vuetify.breakpoint.name);
    setTimeout(function() {
      v.readGames();
    }, 300);
    v.getSponsorClipsByGame();
    v.readSponsorGame();
    setTimeout(function() {
      v.createChart();
    }, 1000);
    // this.createChart();
  },
  beforeDestroy() {
    window.removeEventListener("orientationchange", this.orientationChange);
    window.removeEventListener("resize", this.resize);
  }
};
</script>

<style>
#pie-chart-report {
  width: 95%;
  height: 300px;
  margin-left: 4%;
}

.report-table-container {
  margin: auto;
  text-align: center;
  width: 100% !important;
  margin-bottom: 5%;
}

.overview-description {
  padding-left: 3%;
  padding-right: 2%;
  padding-top: 7%;
  text-align: justify;
  margin-bottom: 0 !important;
}

.stats-title {
  padding-top: 7%;
  padding-left: 3%;
  font-weight: bold;
  text-align: left;
  margin-bottom: 0 !important;
}

.more-info {
  text-align: left;
  margin-left: 3%;
}

.more-info-title {
  /* color: #673ab7;*/
  font-weight: bold;
}

.more-info-item {
  margin-bottom: 0 !important;
}
.sponsors-report-table .vgt-table.condensed td,
.vgt-table.condensed th.vgt-row-header {
  padding: 0.4em 2.3em 0.4em 2.3em !important;
  font-size: 10px !important;
}

.sponsors-report-table .vgt-table th {
  padding: 0.4em 0.8em 0.4em 0.8em !important;
}

.sponsors-report-table .tablerowheight {
  font-weight: 700 !important;
}

.sponsors-report-table .vgt-table thead th {
  padding-right: 0px !important;
}

.overview-icon .v-image__image--cover {
  background-size: contain !important;
}
</style>


